import { writable } from "svelte/store"

export const windowInnerWidth = writable(0)
export const windowInnerHeight = writable(0)
